import { Classroom, User } from 'types/schema-generated-types';

const getClassroomPrimaryEducator = (classroom: Classroom): User | null => {
  if (!classroom) return null;

  return (
    classroom.users?.find(x => x.classroomRoles?.some(y => y.name === 'EDUCATOR'))?.user ??
    classroom.users?.[0]?.user ??
    null
  );
};

export default getClassroomPrimaryEducator;
